import React, { useState } from "react";
import { maxBy } from "lodash";
import Chart from "./chart";
import useGauges from "./chart/useGauges";
import Legend from "./legend";
import useLegend from "./legend/useLegend";
import { StackBarChartProps } from "./model";

const HorizontalStackedBarChart = ({
  locale,
  className,
  total,
  gauges,
  displayNullValues,
  sort,
  limit,
  mainUnit,
  tooltip,
  onClickGauge,
  isFullscreen,
  displayVolumes,
  metric,
  chartValuesFormat = "relative",
  isPNG,
}: StackBarChartProps) => {
  const [hovered, setHovered] = useState("");
  const { filteredGauges, sortedGauges, fullTotal } = useGauges(
    gauges,
    displayNullValues,
    sort,
    limit,
    total,
    isFullscreen,
    chartValuesFormat
  );
  const legendSeries = useLegend(filteredGauges);

  const maxCount = maxBy(sortedGauges, "sortCount").sortCount;

  return (
    <div className={className}>
      <Legend
        series={legendSeries}
        setHovered={setHovered}
        locale={locale}
        onClickLegend={(uid) => onClickGauge(null, null, uid)} // Legends only filter on the "against" pivot
        total={total}
        metric={metric}
        displayVolumes={displayVolumes}
      />
      <Chart
        filteredGauges={filteredGauges}
        sortedGauges={sortedGauges}
        fullTotal={fullTotal}
        limit={limit}
        locale={locale}
        mainUnit={mainUnit}
        tooltip={tooltip}
        displayNullValues={displayNullValues}
        onClickGauge={onClickGauge}
        isFullscreen={isFullscreen}
        hovered={hovered}
        metric={metric}
        chartValuesFormat={chartValuesFormat}
        maxCount={maxCount}
        isPNG={isPNG}
      />
    </div>
  );
};

export default HorizontalStackedBarChart;
